/**
 * Intercom's unread count for the page, from the SDK's onUnreadCountChange (IntercomWidget registers it once),
 * for components that read it with useSyncExternalStore: the platform agent's companion launcher shows it, as
 * Intercom's own launcher would.
 */
let count = 0;
const listeners = new Set();

export function setIntercomUnreadCount(next) {
  const value = Number.isFinite(next) && next > 0 ? next : 0;

  if (value === count) {
    return;
  }

  count = value;
  listeners.forEach((listener) => listener());
}

export function getIntercomUnreadCount() {
  return count;
}

export function subscribeIntercomUnreadCount(listener) {
  listeners.add(listener);

  return () => listeners.delete(listener);
}
